exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-a0e6496c] { margin-bottom: 15px;\n}\n", ""]);

// exports
